import AmanaLogo from '@assets/images/logos/brands/amana.svg';
import JennAirLogo from '@assets/images/logos/brands/jennair.svg';
import KitchenAidLogo from '@assets/images/logos/brands/kitchenaid.svg';
import MaytagLogo from '@assets/images/logos/brands/maytag.svg';
import WhirlpoolLogo from '@assets/images/logos/brands/whirlpool.svg';
import cn from 'classnames';

const classes = {
  root: 'flex flow-row gap-x-6 md:gap-x-3 lg:gap-x-5 gap-y-4 content-center items-center',
  text: 'self-center text-sm',
  logos: {
    base: 'self-center',
    whirlpool: 'h-[25px] md:h-[18px] lg:h-[25px]',
    kitchenaid: 'h-[10px] md:h-[9px] lg:h-[12px]',
    maytag: 'h-[28px] md:h-[18px] lg:h-[24px]',
    amana: 'h-[12px] md:h-[10px] lg:h-[14px]',
    jennair: 'h-[22px] md:h-[18px] lg:h-[25px]'
  }
};

type BrandLogosProps = {
  className?: string;
  inline?: boolean;
};

const BrandLogos = ({ className = '', inline = false }: BrandLogosProps) => (
  <section className={cn(classes.root, className)}>
    <span className={cn(classes.text, { ['w-full']: !inline })}>Our brands:</span>
    <img src={WhirlpoolLogo} className={cn(classes.logos.base, classes.logos.whirlpool)} alt='Whirlpool logo' />
    <img src={KitchenAidLogo} className={cn(classes.logos, classes.logos.kitchenaid)} alt='KitchenAid logo' />
    <img src={MaytagLogo} className={cn(classes.logos, classes.logos.maytag)} alt='Maytag logo' />
    <img src={AmanaLogo} className={cn(classes.logos, classes.logos.amana)} alt='Amana logo' />
    <img src={JennAirLogo} className={cn(classes.logos, classes.logos.jennair)} alt='JennAir logo' />
  </section>
);

export default BrandLogos;
